import { RestServiceAbstract } from "../../../core/base/rest.service.abstract";
import { catchError, map} from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Injectable, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ResponseModel } from "../../../core/base/response.model";

@Injectable({
  providedIn: 'root',
})
export class PreordersDeliveriesService extends RestServiceAbstract {
  private readonly destroyRef = inject(DestroyRef);

  loadPreordersDeliveries(idf: string) {
    return this.get(`/${this.RESOURCE}/preorders/delivery/grippe2025/${idf}`).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((data: Object) => new ResponseModel(data)),
      catchError((err: any) => throwError(() => err))
    );
  }
}
